import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FormViewHide = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FormViewHide' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M3,12 L6,12 C6.5,14.5 9.27272727,17 12,17 C14.7272727,17 17.5,14.5 18,12 L21,12 M12,17 L12,20 M7.5,15.5 L5.5,17.5 M16.5,15.5 L18.5,17.5' />
  </StyledIcon>
);
